import { Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

export type ResultBannerType = 'success' | 'error' | 'info' | 'warning';

@Component({
  selector: 'dbx-result-banner',
  standalone: true,
  imports: [MatIcon],
  templateUrl: './result-banner.component.html',
  styleUrl: './result-banner.component.scss',
})
export class ResultBannerComponent {
  type = input.required<ResultBannerType>();
  message = input.required<string>();

  get icon(): string {
    switch (this.type()) {
      case 'success':
        return 'check_circle';
      case 'error':
        return 'cancel';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
    }
  }
}
